/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import CryptoJS from "crypto-js";

const dates = {
  convert: function (d) {
    return d.constructor === Date
      ? d
      : d.constructor === Array
      ? new Date(d[0], d[1], d[2])
      : d.constructor === Number
      ? new Date(d)
      : d.constructor === String
      ? new Date(d)
      : typeof d === "object"
      ? new Date(d.year, d.month, d.date)
      : NaN;
  },
  compare: function (a, b) {
    return isFinite((a = this.convert(a).valueOf())) &&
      isFinite((b = this.convert(b).valueOf()))
      ? (a > b) - (a < b)
      : NaN;
  },
  inRange: function (d, start, end) {
    return isFinite((d = this.convert(d).valueOf())) &&
      isFinite((start = this.convert(start).valueOf())) &&
      isFinite((end = this.convert(end).valueOf()))
      ? start <= d && d <= end
      : NaN;
  },

  addDays: function (date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
};
export default class Crypt {
  constructor() {
    this.key = "1234abcd0998ijdf";
  }

  encrypt(a) {
    return CryptoJS.AES.encrypt(a, this.key, {}).toString();
  }

  decrypt(a) {
    return CryptoJS.AES.decrypt(a.toString(), this.key, {}).toString(
      CryptoJS.enc.Utf8
    );
  }

  encryptJson(a) {
    try {
      if (typeof a === "object") {
        let string = JSON.stringify(a);
        return CryptoJS.AES.encrypt(string, this.key, {}).toString();
      }
      return "";
    } catch {
      return "";
    }
  }

  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  isValidToken(b) {
    let a = new Date();
    b = new Date(b * 1000);
    let e = dates.compare(a, b) === -1;

    return e;
  }

  decryptJson(a) {
    try {
      if (typeof a === "string") {
        let bytes = CryptoJS.AES.decrypt(a, this.key);
        let json = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return json;
      }
      return "";
    } catch {
      return "";
    }
  }
}
